import { useQuery } from '@tanstack/react-query';
import { AskRequest, AskRequestStatus } from '@hone-automation/common';
import { transformApiTrxToUITrx, useFlaggedTransactions } from 'hooks/flaggedTransactions';
import { shallow } from 'zustand/shallow';
import { useParams } from 'react-router-dom';
import { makeRemoteQueueRequests } from '../main/factories/usecases';

const getAskRequests = makeRemoteQueueRequests();

export const useQueueRequestsQuery = (status?: AskRequestStatus, isQueue = false, enabled = true) => {
  const { locationId } = useParams();
  const { activeFlaggedTransaction } = useFlaggedTransactions(
    state => ({
      activeFlaggedTransaction: state.activeFlaggedTransaction,
    }),
    shallow
  );
  return useQuery({
    gcTime: 0,
    queryKey: ['queueRequests', status, locationId],
    enabled: enabled && Boolean(locationId),
    queryFn: async () => {
      if (!locationId) {
        return [];
      }
      const response = await getAskRequests.get({ locationId, statuses: status });
      const requests: AskRequest[] = Array.isArray(response)
        ? response
        : (response as { requests?: AskRequest[] })?.requests ?? [];

      if (!isQueue) {
        const sortedRequests = requests.sort((a, b) => {
          return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
        });

        const trx = sortedRequests.find((trx: AskRequest) => trx.id === activeFlaggedTransaction?.id);
        let nextActiveFlaggedTransaction = requests[0];
        if (trx) {
          nextActiveFlaggedTransaction = trx;
        }
        useFlaggedTransactions.setState({
          activeFlaggedTransaction: transformApiTrxToUITrx(nextActiveFlaggedTransaction),
        });
      }

      return requests;
    },
  });
};
